export const IS_PRODUCT = true;
// Use proxy in development to avoid cross-origin cookie issues
export const PROXY_URL =
  process.env.NODE_ENV === 'development'
    ? '/'
    : 'https://api.stage.barcalink.com/';
export const SOCKET_URL = 'https://api.stage.barcalink.com/users';
export const COOKIE_NAME = 'fan_sid';
export const FAKE_COOKIE = 'fake_cookie';
export const COOKIE_MAX_AGE = 24 * 60 * 60 * 1000;
// Barcelona local time, including CET/CEST. Etc/GMT zones use an inverted
// POSIX sign and do not follow daylight saving.
export const TIME_ZONE = 'Europe/Madrid';
